import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RouterContext, goTo } from './Router';
import { getKeyHandler } from '../structure/FlowForm';
import './Link.css';
/**
 * A link is a clickable element that navigates to a new location (same origin).
 */
const Link = ({ to, mode = 'push', className, children, focussable = 'flow', onClick, style }) => {
    const ctx = React.useContext(RouterContext);
    const handleKeyDown = focussable != 'normal' ? getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: 'both',
    }) : undefined;
    if (to.startsWith('http') || to.startsWith('//'))
        throw new Error('Link target must be same origin');
    function clicked(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
        goTo(ctx, to, mode);
    }
    return _jsx("a", { href: to, className: `routerLink ${className !== null && className !== void 0 ? className : ''}${focussable != 'normal' ? ' flowFocussable' : ''}${focussable == 'sideways' ? ' sidewayFocus' : ''}`, onClick: clicked, tabIndex: focussable ? 0 : undefined, onKeyDown: handleKeyDown, draggable: false, style: style, children: children });
};
export default Link;
